import Vue from 'vue'
import App from './App.vue'
import router from './router'
import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import Datetime from 'vue-datetime'
import 'vue-datetime/dist/vue-datetime.css'
import Axios from 'axios' 
import VueSweetalert2 from 'vue-sweetalert2';
import VueScrollTo from 'vue-scrollto';
import VueAnalytics from 'vue-analytics'
var version = JSON.stringify(require('../package.json').version);
Vue.prototype.$app_version = version;
Vue.use(VueScrollTo)

var googleAnEnabled = true;
console.log( process.env.NODE_ENV)
if (  process.env.NODE_ENV === 'production' )
{
    googleAnEnabled = false;
}


Vue.use(VueAnalytics, {
  id: 'UA-129884928-2',
  router,
  debug : { enabled : googleAnEnabled }
  /*autoTracking: {
    screenview: true
  },
  debug: {
    sendHitTask: process.env.NODE_ENV === 'production'
  }*/
})

Vue.use(Datetime)
Vue.prototype.$http = Axios;
Vue.use(BootstrapVue);
Vue.use(require('vue-moment'));
Vue.use(VueSweetalert2);

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
